import React, { useEffect } from 'react';
import Header from '../Component/Header';
import Footer from '../Component/Footer';
import { Link } from 'react-router-dom';
function Club() {
  useEffect(() => {
    document.title = 'Club-  CARMEL CONVENT SCHOOL, DHARUHERA';
  }, []);
  return (
    <>
      <Header />
      <div className="sliderbg"></div>
      <div className="innerpage">
        <div className="container">
          <div className="row">
            <div className="col-12">
              <ul className="breadcrumbli">
                <li><Link to="/"> Home </Link></li>
                <li>Academics</li>
                <li>Club</li>
              </ul>
            </div>
            <div className="col-lg-12">
              <h2 className="innerheading">Club</h2>
            </div>
          </div>


          <div className="row g-4">
            <div className="col-lg-12">
              <div className="club-card">
                <h5>Our Vibrant Clubs</h5>
                <p>
                  The School offers various clubs for the students. The club activities
                  provide ample opportunities to the students to engage themselves in a
                  wide variety of co-curricular activities.
                </p>
                <ul className="Clubmainlist">
                  <li>Science & Eco Club</li>
                  <li>Peace & Kindness Club</li>
                  <li>Health & Wellness Club</li>
                  <li>Heritage Club</li>
                  <li>Literary Club</li>
                </ul>
              </div>
            </div>
            {/* <div className="col-lg-6">
              <div className="club-card">
                <h5>Our Facilities</h5>
                <p><b>Take a Campus Tour</b></p>
                <p>
                  World-class facilities designed to inspire every dimension of student
                  life.
                </p>
                <ul className="Clubmainlist">
                  <li>Library</li>
                  <li>Computer Lab</li>
                  <li>Medical Room</li>
                  <li>Digital Classroom</li>
                  <li>Dance Room</li>
                  <li>Composite Science Lab</li>
                  <li>Transport Facility</li>
                  <li>Safe Drinking Water (RO System)</li>
                  <li>Sports Area</li>
                  <li>Lift</li>
                  <li>Fire Safety</li>
                  <li>Taekwondo Training Room</li>
                  <li>Power Backup</li>
                </ul>
              </div>
            </div> */}

          </div>
          <div className='py-2'></div>
          <div className="accordion" id="clubAccordion">
            {/* Science & Eco Club */}
            <div className="accordion-item">
              <h2 className="accordion-header" id="scienceHeading">
                <button
                  className="accordion-button"
                  type="button"
                  data-bs-toggle="collapse"
                  data-bs-target="#scienceClub"
                  aria-expanded="true"
                  aria-controls="scienceClub"
                >
                  Science & Eco Club
                </button>
              </h2>

              <div
                id="scienceClub"
                className="accordion-collapse collapse show"
                aria-labelledby="scienceHeading"
                data-bs-parent="#clubAccordion"
              >
                <div className="accordion-body">
                  <div className="row g-4 Club-gallery">
                    <div className="col-xl-3 col-lg-4 col-md-6 col-sm-6 col-12">
                      <div className="Club-card">
                        <img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/CCSDH/public/Images/Science-1.jpeg" alt="Science & Eco Club" />
                      </div>
                    </div>
                    <div className="col-xl-3 col-lg-4 col-md-6 col-sm-6 col-12">
                      <div className="Club-card">
                        <img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/CCSDH/public/Images/Science-2.jpeg" alt="Science & Eco Club" />
                      </div>
                    </div>
                    <div className="col-xl-3 col-lg-4 col-md-6 col-sm-6 col-12">
                      <div className="Club-card">
                        <img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/CCSDH/public/Images/Science-3.jpeg" alt="Science & Eco Club" />
                      </div>
                    </div>
                    <div className="col-xl-3 col-lg-4 col-md-6 col-sm-6 col-12">
                      <div className="Club-card">
                        <img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/CCSDH/public/Images/Science-4.jpeg" alt="Science & Eco Club" />
                      </div>
                    </div>
                    <div className="col-xl-3 col-lg-4 col-md-6 col-sm-6 col-12">
                      <div className="Club-card">
                        <img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/CCSDH/public/Images/Science-5.jpeg" alt="Science & Eco Club" />
                      </div>
                    </div>
                    <div className="col-xl-3 col-lg-4 col-md-6 col-sm-6 col-12">
                      <div className="Club-card">
                        <img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/CCSDH/public/Images/Science-6.jpeg" alt="Science & Eco Club" />
                      </div>
                    </div>
                    <div className="col-xl-3 col-lg-4 col-md-6 col-sm-6 col-12">
                      <div className="Club-card">
                        <img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/CCSDH/public/Images/Science-7.jpeg" alt="Science & Eco Club" />
                      </div>
                    </div>
                    <div className="col-xl-3 col-lg-4 col-md-6 col-sm-6 col-12">
                      <div className="Club-card">
                        <img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/CCSDH/public/Images/Science-8.jpeg" alt="Science & Eco Club" />
                      </div>
                    </div>
                    <div className="col-xl-3 col-lg-4 col-md-6 col-sm-6 col-12">
                      <div className="Club-card">
                        <img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/CCSDH/public/Images/Science-9.jpeg" alt="Science & Eco Club" />
                      </div>
                    </div>
                    <div className="col-xl-3 col-lg-4 col-md-6 col-sm-6 col-12">
                      <div className="Club-card">
                        <img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/CCSDH/public/Images/Science-10.jpeg" alt="Science & Eco Club" />
                      </div>
                    </div>
                    <div className="col-xl-3 col-lg-4 col-md-6 col-sm-6 col-12">
                      <div className="Club-card">
                        <img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/CCSDH/public/Images/Science-11.jpeg" alt="Science & Eco Club" />
                      </div>
                    </div>
                    <div className="col-xl-3 col-lg-4 col-md-6 col-sm-6 col-12">
                      <div className="Club-card">
                        <img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/CCSDH/public/Images/Science-12.jpeg" alt="Science & Eco Club" />
                      </div>
                    </div>

                  </div>
                </div>
              </div>
            </div>

            {/* Heritage Club */}
            <div className="accordion-item">
              <h2 className="accordion-header" id="heritageHeading">
                <button
                  className="accordion-button collapsed"
                  type="button"
                  data-bs-toggle="collapse"
                  data-bs-target="#heritageClub"
                  aria-expanded="false"
                  aria-controls="heritageClub"
                >
                  Heritage Club
                </button>
              </h2>

              <div
                id="heritageClub"
                className="accordion-collapse collapse"
                aria-labelledby="heritageHeading"
                data-bs-parent="#clubAccordion"
              >
                <div className="accordion-body">
                  <div className="row g-4 Club-gallery">
                    <div className="col-xl-3 col-lg-4 col-md-6 col-sm-6 col-12">
                      <div className="Club-card">
                        <img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/CCSDH/public/Images/Heritageclub-1.jpeg" alt="Heritage Club 1" />
                      </div>
                    </div>
                    <div className="col-xl-3 col-lg-4 col-md-6 col-sm-6 col-12">
                      <div className="Club-card">
                        <img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/CCSDH/public/Images/Heritageclub-2.jpeg" alt="Heritage Club 2" />
                      </div>
                    </div>
                    <div className="col-xl-3 col-lg-4 col-md-6 col-sm-6 col-12">
                      <div className="Club-card">
                        <img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/CCSDH/public/Images/Heritageclub-3.jpeg" alt="Heritage Club 3" />
                      </div>
                    </div>
                    <div className="col-xl-3 col-lg-4 col-md-6 col-sm-6 col-12">
                      <div className="Club-card">
                        <img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/CCSDH/public/Images/Heritageclub-4.jpeg" alt="Heritage Club 4" />
                      </div>
                    </div>
                    <div className="col-xl-3 col-lg-4 col-md-6 col-sm-6 col-12">
                      <div className="Club-card">
                        <img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/CCSDH/public/Images/Heritageclub-5.jpeg" alt="Heritage Club 5" />
                      </div>
                    </div>
                    <div className="col-xl-3 col-lg-4 col-md-6 col-sm-6 col-12">
                      <div className="Club-card">
                        <img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/CCSDH/public/Images/Heritageclub-6.jpeg" alt="Heritage Club 6" />
                      </div>
                    </div>
                    <div className="col-xl-3 col-lg-4 col-md-6 col-sm-6 col-12">
                      <div className="Club-card">
                        <img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/CCSDH/public/Images/Heritageclub-7.jpeg" alt="Heritage Club 7" />
                      </div>
                    </div>
                    <div className="col-xl-3 col-lg-4 col-md-6 col-sm-6 col-12">
                      <div className="Club-card">
                        <img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/CCSDH/public/Images/Heritageclub-8.jpeg" alt="Heritage Club 8" />
                      </div>
                    </div>
                    <div className="col-xl-3 col-lg-4 col-md-6 col-sm-6 col-12">
                      <div className="Club-card">
                        <img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/CCSDH/public/Images/Heritageclub-9.jpeg" alt="Heritage Club 9" />
                      </div>
                    </div>
                    <div className="col-xl-3 col-lg-4 col-md-6 col-sm-6 col-12">
                      <div className="Club-card">
                        <img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/CCSDH/public/Images/Heritageclub-10.jpeg" alt="Heritage Club 10" />
                      </div>
                    </div>
                    <div className="col-xl-3 col-lg-4 col-md-6 col-sm-6 col-12">
                      <div className="Club-card">
                        <img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/CCSDH/public/Images/Heritageclub-11.jpeg" alt="Heritage Club 11" />
                      </div>
                    </div>
                    <div className="col-xl-3 col-lg-4 col-md-6 col-sm-6 col-12">
                      <div className="Club-card">
                        <img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/CCSDH/public/Images/Heritageclub-12.jpeg" alt="Heritage Club 12" />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
}
export default Club;
